import { createGlobalStyle } from "styled-components";
import tw, { GlobalStyles as BaseStyles } from "twin.macro";
import { up } from "~/features/app/screens";

const CustomStyles = createGlobalStyle`
  :root {
    --header-height: 64px;
    --announcement-bar-height: 40px;
    --sub-nav-height: 112px;

    ${up("lg")} {
      --header-height: 72px;
      --announcement-bar-height: 48px;
      --sub-nav-height: 72px;
    }
  }

  html {
    ${tw`text-black-100-light cursor-default min-h-full`}
  }

  body {
    ${tw`font-saans text-mobile-body-30-normal lg:text-desktop-body-30-normal antialiased`}
  }

  html,
  body,
  #__next {
    ${tw`flex flex-col flex-1`}
  }

  #__next {
    ${tw`relative`}
  }

  .grecaptcha-badge {
    ${tw`opacity-0 pointer-events-none z-[99999]`}
  }

  .hide-scrollbar {
    ${tw`![scrollbar-width:none]`}
  }

  .hide-scrollbar::-webkit-scrollbar {
    ${tw`!hidden`}
  }
`;

export const AppStyles = () => (
  <>
    <BaseStyles />
    <CustomStyles />
  </>
);
